import {Component, Inject, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {LocalStorageService} from 'src/app/local-storage.service';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {MainDataModels} from 'src/app/models/maindata-models';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {v4 as uuidv4} from 'uuid';
import {faSearchLocation} from '@fortawesome/free-solid-svg-icons';
import {UserAuthenticationService} from '../../../../services/user-authentication.service';

@Component({
  selector: 'app-time-recorder',
  templateUrl: './time-recorder.component.html',
  styleUrls: ['./time-recorder.component.scss'],
})
export class TimeRecorderComponent implements OnInit {
  faSearchLocation = faSearchLocation;
  @Input() formGroupTimeRecorder: UntypedFormGroup;
  public cardTitle: string ='MAIN_APP_DIALOG.INPUT_DIALOG.START_TIME_RECORD.title';
  objekte: Array<ServiceAppModels.SearchFieldResponseItem> = []; // Leeres Objekte-Array erstellen (SearchFieldResponseObjekt[])
  filteredDescriptions?: Observable<ServiceAppModels.SearchFieldResponseItem[]>;
  private dbStorage: string = 'ServiceAppDB';
  private dbStammdaten?: ServiceAppModels.Stammdaten;
  private currAnwender: BenutzerModels.Anwender;
  private currTermin?: ServiceAppModels.SA_Objekt;
  private choosedItem?: ServiceAppModels.SearchFieldResponseItem;

  public dbKostenstellen?: ServiceAppModels.SA_CostCenter[];
  public startZeit: string = '';

  public fldWorkplaceRequired = false;
  public timeRecordingItem?: ServiceAppModels.TimeRecordingItem;
  private fromExistingTimeRecordingItem?: ServiceAppModels.TimeRecordingItem;

  constructor(
    private swissSettings: SwissSettingsService,
    private userAuthService: UserAuthenticationService,
    private localStorageService: LocalStorageService,
    private _datumFormatPipe: DatumFormatPipe,
    private svcSA: ServiceAppService,
    public dialogRef: MatDialogRef<TimeRecorderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ServiceAppModels.TimeRecordingItem
  ) {
    this.formGroupTimeRecorder = new UntypedFormGroup({
      fldObjekt: new UntypedFormControl(),
      fldKostenstellen: new UntypedFormControl(),
      fldStartZeit: new UntypedFormControl(),
      fldArbeitsort: new UntypedFormControl(),
    });

    this.currAnwender = this.userAuthService.getCurrentAuthenticatedUser()!;
    this.currTermin = this.svcSA.getTermin();
    this.fromExistingTimeRecordingItem = data;
  }

  ngOnInit(): void {
    // Aktuelle Zeit vorbelegen
    this.startZeit = this._datumFormatPipe.transformOnlyTime(new Date());
    this.formGroupTimeRecorder.controls['fldStartZeit'].setValue(
      this.startZeit
    );

    // Objekte für Suche laden
    this.objekte = [];
    this.svcSA.getSuchfeldBeschreibungen().then((res) => {
      this.objekte = this.objekte.concat(res);
      console.log('Ermittelte Objekte', this.objekte);

      this.filteredDescriptions = this.formGroupTimeRecorder.controls[
        'fldObjekt'
      ].valueChanges.pipe(
        startWith(''),
        map((value) => this._filter(value))
      );

      /* Objekt vorbelegen */
      if (this.fromExistingTimeRecordingItem) {
        if (this.fromExistingTimeRecordingItem.serviceID) {
          let obj = this.objekte.filter(
            (x) => x.serviceID === this.fromExistingTimeRecordingItem!.serviceID
          )[0];
          this.formGroupTimeRecorder.controls['fldObjekt'].setValue(obj);
          this.choosedItem = obj;
        } else {
          let obj = this.objekte.filter(
            (x) =>
              x.objectID === this.fromExistingTimeRecordingItem!.objectID &&
              this.fromExistingTimeRecordingItem!.serviceID === null
          )[0];
          this.formGroupTimeRecorder.controls['fldObjekt'].setValue(obj);
          this.choosedItem = obj;
        }
        if (this.fromExistingTimeRecordingItem.workPlace)
          this.formGroupTimeRecorder.controls['fldArbeitsort'].setValue(
            this.fromExistingTimeRecordingItem.workPlace
          );
      } else if (this.currTermin) {
        let obj = this.objekte.filter(
          (x) => x.serviceID === this.currTermin!.serviceID
        )[0];
        this.formGroupTimeRecorder.controls['fldObjekt'].setValue(obj);
        this.choosedItem = obj;
      }
    });

    this.loadCostcenterFromIndexedDB();
  }

  async loadCostcenterFromIndexedDB(): Promise<boolean> {
    return this.localStorageService
      .get('stammdaten', this.dbStorage)
      .then((value) => {
        if (value === false) {
          // Es konnte keinen Wert in der indexeddb für Mitarbeiter ermittelt werden
          return false;
        } else {
          // Die Stammdaten konnten geladen werden
          if (value) {
            this.dbStammdaten = <ServiceAppModels.Stammdaten>value;
            this.dbKostenstellen = this.dbStammdaten.sA_CostCenter;

            /* Kostenstelle vorbelegen */
            if (this.fromExistingTimeRecordingItem) {
              this.formGroupTimeRecorder.controls['fldKostenstellen'].setValue(
                this.fromExistingTimeRecordingItem.costCenterID
              );
              this.kostenstelleChange(
                this.fromExistingTimeRecordingItem.costCenterID
              );
            } else {
              let defaultCostCenter =
                  this.userAuthService.getCurrentAuthenticatedUser()?.sA_DefaultCostCenter;
              if (defaultCostCenter) {
                this.formGroupTimeRecorder.controls[
                  'fldKostenstellen'
                ].setValue(defaultCostCenter);
                this.kostenstelleChange(defaultCostCenter);
              }
            }
          }
          return true;
        }
      });
  }

  kostenstelleChange(value: number) {
    // Wenn die Kostenstelle ändert, wird der Wert für die Arbeitsbezeichnung neu gesetzt, aber nur wenn der Text nicht schon angepasst wurde
    if (this.dbKostenstellen) {
      let neueKostenstelle = this.dbKostenstellen.filter(
        (k) => k.costCenterID == value
      )[0];

      this.fldWorkplaceRequired = neueKostenstelle.obligatoryWorkplace;
      // Formular-Feld muss geresetet werden, damit der * für required angezeigt oder weggenommen wird
      let fieldValue =
        this.formGroupTimeRecorder.controls['fldArbeitsort'].value;
      this.formGroupTimeRecorder.controls['fldArbeitsort'].reset();
      if (!this.fldWorkplaceRequired)
        this.formGroupTimeRecorder.controls['fldArbeitsort'].setValidators(
          null
        );
      this.formGroupTimeRecorder.controls['fldArbeitsort'].setValue(fieldValue);
    }
  }

  setLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const longitude = position.coords.longitude;
          const latitude = position.coords.latitude;
          this.callApi(longitude, latitude);
        },
        () => {
          console.log('error');
        },
        {
          enableHighAccuracy: true,
        }
      );
    }
  }

  private callApi(Longitude: number, Latitude: number) {
    this.svcSA.reverseGeocoding(Latitude, Longitude).subscribe({
      next: (res: any) => {
        if (res.address.city) {
          this.formGroupTimeRecorder.controls['fldArbeitsort'].setValue(
            res.address.city
          );
        } else if (res.address.town) {
          this.formGroupTimeRecorder.controls['fldArbeitsort'].setValue(
            res.address.town
          );
        } else if (res.address.village) {
          this.formGroupTimeRecorder.controls['fldArbeitsort'].setValue(
            res.address.village
          );
        }
      },
    });
  }

  getObjektDesc(item: MainDataModels.SearchFieldResponseObjekt) {
    if (item) {
      return item.beschreibung;
    } else return '';
  }

  // Suchelement wurde angeklickt
  selectedSearchItem(event: any) {
    if (this.swissSettings.getWebConfig().debugMode)
      console.log(event.option.value);
    if (event) {
      this.choosedItem = event.option.value;
      if (this.choosedItem?.serviceID) {
        let termin = this.svcSA.getTerminByServiceID(
          this.choosedItem?.serviceID
        );
        if (termin && termin.fK_AutoCostCenter)
          this.formGroupTimeRecorder.controls['fldKostenstellen'].setValue(
            termin.fK_AutoCostCenter
          );
      } else if (this.choosedItem?.objectID) {
        let obj = this.svcSA.getObjektByObjektID(this.choosedItem?.objectID);
        if (obj && obj.fK_AutoCostCenter)
          this.formGroupTimeRecorder.controls['fldKostenstellen'].setValue(
            obj.fK_AutoCostCenter
          );
      }
    }
  }

  private _filter(value: string | any): ServiceAppModels.SearchFieldResponseItem[] {
    if (value && typeof value == 'string') {
      const filterValue = value.toLowerCase();

      if (this.objekte && this.objekte.length > 0) {
        // Sternsuche
        if (filterValue.length > 1 && filterValue[0] === '*') {
          const searchValue = filterValue.substring(1, filterValue.length);
          return this.objekte.filter(
            (objekt) =>
              objekt.beschreibung &&
              objekt.beschreibung.toLowerCase().indexOf(searchValue) >= 0
          );
        } else {
          return this.objekte.filter(
            (objekt) =>
              objekt.beschreibung &&
              objekt.beschreibung.toLowerCase().indexOf(filterValue) === 0
          );
        }
      } else return this.objekte;
    } else {
      return [];
    }
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  async save() {
    console.log('Zeit', this.startZeit);
    this.startZeit = this.formGroupTimeRecorder.controls['fldStartZeit'].value;

    this.timeRecordingItem = {
      employeeID: this.currAnwender.employeeID,
      mandator: this.currAnwender.mandatorID,
      rowID: uuidv4(),
      serviceID: this.choosedItem!.serviceID,
      objectID: this.choosedItem!.objectID,
      day: new Date(
        this._datumFormatPipe.transform(new Date(), 'yyyy-MM-ddT') + '00:00:00'
      ),
      startTime: new Date(
        this._datumFormatPipe.transform(new Date(), 'yyyy-MM-ddT') +
          this.startZeit +
          ':00'
      ),
      endTime: undefined,
      costCenterID:
        this.formGroupTimeRecorder.controls['fldKostenstellen'].value,
      recordingState: ServiceAppModels.RecordingState.InRecording,
      onlyTime: this.startZeit,
      workPlace: this.formGroupTimeRecorder.controls['fldArbeitsort'].value,
    };

    // Dann Eintrag in Indexed-DB speichern
    await this.svcSA.saveTimeRecordingItem(this.timeRecordingItem);
    this.dialogRef.close(this.timeRecordingItem);
  }
}
